import { isBoolean, isNumber, isString, isUndefined } from "lodash";
import React, { isValidElement } from "react";

const isValidReactElement = (val: any) => {
  if (
    isValidElement(val) ||
    isString(val) ||
    isUndefined(val) ||
    isNumber(val) ||
    isBoolean(val) ||
    val === null
  ) {
    return true;
  }

  if (Array.isArray(val) && val.every((item) => isValidReactElement(item)))
    return true;
};

export function isValidReactChildren(
  val: any
): val is React.ReactNode | JSX.Element | React.ReactNode[] | JSX.Element[] {
  if (isValidReactElement(val)) return true;
  return false;
}
